<div *ngIf="(appointmentSettingModel$ | async) as appointmentSettingModel">
  <form [formGroup]="formGroup">
  <div class="modal-header">
    <button type="button" class="close close-lg pull-right" aria-label="Close"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h1 class="modal-title">Appointment Settings</h1>
  </div>
  <div class="modal-body">
     <!--div class="col-sm-6 col-md-6 col-lg-6" style="padding: 4px; align-items: stretch"-->
        <div class="form-panel">

            <div class="form-check" style="padding-bottom: 16px;">
              <p-checkbox class="form-check-input" id="birthday"
                          binary="true" [formControl]="formGroup.controls['enableBirthday']"></p-checkbox>

              <label class="form-check-label" for="birthday" style="margin-left: 16px">Display <img src="img/icon_birthday.png" style="width: 16px; height:16px;" /> if the {{'_Patient_' | translate}}'s birthday is today.</label>
            </div>

            <div class="form-check" style="padding-bottom: 16px;">
              <p-checkbox class="form-check-input" id="twoway"
                          binary="true"  [formControl]="formGroup.controls['enableTwoway']"></p-checkbox>
              <label class="form-check-label" for="twoway" style="margin-left: 16px">Display <img src="img/icon_two-way.png" style="width: 16px; height:16px;" /> if the {{'_Patient_' | translate}} has an unanswered text message</label>
            </div>

            <div class="form-check" style="padding-bottom: 16px;">
              <p-checkbox class="form-check-input" id="destinator" binary="true"
                          [formControl]="formGroup.controls['enableIncorrectDestinator']"></p-checkbox>
              <label class="form-check-label" for="destinator" style="margin-left: 16px">Display <img src="img/media_missing_sms.png" style="width: 16px; height:16px;" /> &nbsp; <img src="img/media_missing_email.png" style="width: 16px; height:16px;" /> if the {{'_Patient_' | translate}} is missing contact information</label>
            </div>

          <div class="form-check" style="padding-bottom: 16px;">
            <p-checkbox class="form-check-input" id="provider" binary="true"
                        [formControl]="formGroup.controls['enableProviders']"></p-checkbox>
            <label class="form-check-label" for="provider" style="margin-left: 16px">Display a column to show provider name and location</label>
          </div>

          <div *ngIf="isAuthenticatedFromAdmin$ | async as isAuthenticatedFromAdmin">
            <hr/>
            For Admin Only
            <hr/>

            <div class="form-check" style="padding-bottom: 16px;">
              <p-checkbox class="form-check-input" id="viewDeleted" binary="true"
                          [formControl]="formGroup.controls['viewDeleted']"></p-checkbox>
              <label class="form-check-label" for="viewDeleted" style="margin-left: 16px">Display reminder which are deleted </label>
            </div>

            <div class="form-check" style="padding-bottom: 16px;">
              <p-checkbox class="form-check-input" id="viewVoid" binary="true"
                          [formControl]="formGroup.controls['viewVoid']"></p-checkbox>
              <label class="form-check-label" for="viewVoid" style="margin-left: 16px">Display appointments which are marked void in Client software</label>
            </div>
          </div>

            <img *ngIf="(loading$ | async)" style="width: 30px; padding-left: 2px; margin-top: -3px; margin-left: 2px;"
                 src="img/loading.gif" />
        </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click) = "updateAppointmentSettings()" name="update-settings-btn"
            [disabled]="formGroup.pristine">Save</button>
    <button type="button" class="btn btn-default" (click)="onCancel()">Cancel</button>
  </div>
  </form>
</div>
